import http from "../utils/http";

// 통화 코드 조회
export const getCurrencyCodes = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/currencyCodes")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 업종/업태 코드 조회
export const getIndustryCodes = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/industryCodes")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 국가코드 조회
export const getKoicaNationalCodes = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/koicaNationalCodes")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 체류코드 조회
export const getStayCodes = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/stayCodes")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 세무소 코드 조회
export const getTaxOfficeCodes = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/taxOfficeCodes")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 개인카드 코드 조회
export const getConstantsCards = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/cards")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 법인카드 코드 조회
export const getConstantsCcds = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/ccds")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 개인뱅킹 코드 조회
export const getConstantsPbks = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/pbks")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 법인뱅킹 코드 조회
export const getConstantsCbks = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/cbks")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 지역 코드 조회
export const getRegions = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/constants/regions")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};